export default __webpack_public_path__ + "pgnv-assets/361a18fa50e1d5bc598b209631b59e14.png";